import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { registerLicense } from '@syncfusion/ej2-base';
import { sentryScrubber } from '@nooty/smo-data-protection';
import { deploy } from './deploy';
import { UserManager } from './app/autenticacao/user-manager';
import { patchSyncfusionDialogBodyUnlock } from './app/patches/syncfusion-dialog-body-scroll.patch';

patchSyncfusionDialogBodyUnlock();

Sentry.init({
  dsn: "https://7927de2b7787baac5177258b427175a3@o4507306285203456.ingest.us.sentry.io/4507306289856512",
  environment: environment.production ? 'production' : 'development',
  integrations: [
    Sentry.feedbackIntegration({
      // Additional SDK configuration goes in here, for example:
      colorScheme: 'light',
      autoInject: false
    }),
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/saude\.smosc\.com\.br/],  
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

  beforeSend(event: Sentry.ErrorEvent, hint) {
    const manager = new UserManager();

    const authenticatedUser = manager.consultarUsuario();
    
    let user = {
      username: 'N/D',
      userId: 'N/D'
    };

    if (authenticatedUser) {
      user = {
        userId: authenticatedUser.usuarioId?.toString(),
        username: authenticatedUser.username,
      };
    } 

    return sentryScrubber(event, {
      userId: user.username,
      username: user.username,
      version: deploy.version
    });
  }
});

// Registering Syncfusion license key
registerLicense('Ngo9BigBOggjHTQxAR8/V1JGaF5cXGpCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWX5ccHVUQmdeU0N+W0ZWYEs=');


if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
